import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import styled from 'styled-components';


import CircularProgress from '@mui/material/CircularProgress';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../style/theme.js";


/** Composants */
import Logo from '../components/Logo.js'
import NavBar from '../components/NavBar.js'
import Footer from '../components/Footer.js'
import ElementDel from '../components/ElementDel.js'

/** Api */
import { apiElementById } from '../api.js';

const Page = styled.div`
position:relative;
min-height:100vh;
padding-bottom:300px;
`
const Titre = styled.h2`
margin:0 auto;
`
const PageDel = () => {
    const {typeElement, id} = useParams()

    const [element, setElement] = useState({})
    const [loading, setLoading] = useState(true)
    const [erreur, setErreur] = useState(false)

    useEffect(() => {
        apiElementById(typeElement, id)
        .then(res => {
            setElement(res.reponse)
            setLoading(false)
        })
        .catch(error => {
            console.log(error)
            setLoading(false)
            setErreur(true)
        })
    }, [typeElement, id])

    return (
        <Page>
            <Logo/>
            <NavBar/>
            <Titre>{typeElement}</Titre>
            { !loading  && !erreur && element && <ElementDel key={element.id} typeElement={typeElement} elem={element}/>}
            {loading  && <ThemeProvider  theme={theme}><CircularProgress color="secondary"/><h3>Je charge</h3></ThemeProvider> }
            {erreur  && <h3>J'ai rencontré un problème...</h3> }
            <Footer/>
        </Page>
    )
}
export default PageDel